const cities = [
  {
    index: 0,
    key: "seattle",
    name: "Seattle",
    country: "USA",
    year: "2025",
    sites: [
      "Seattle Art Museum",
      "Chihuly Garden and Glass",
      "Space Needle",
      "Museum of Pop Culture",
    ],
    photoCount: 12,
  },
  {
    index: 1,
    key: "cali",
    name: "Cali",
    country: "USA",
    year: "2024",
    sites: [
      "Golden Gate Bridge",
      "The Broad",
      "Los Angeles County Museum of Art",
      "Fisherman’s Wharf",
    ],
    photoCount: 15,
  },
  {
    index: 2,
    key: "montana",
    name: "Montana",
    country: "USA",
    year: "2023",
    sites: [
      "Glacier National Park",
      "Museum of the Rockies",
      "Mount Helena",
      "Big Sky Resort",
    ],
    photoCount: 10,
  },
  {
    index: 3,
    key: "dc",
    name: "DC",
    country: "USA",
    year: "2022",
    sites: [
      "National Gallery of Art",
      "Washington Monument",
      "Hirshhorn Museum",
      "International Spy Museum",
    ],
    photoCount: 11,
  },
  {
    index: 4,
    key: "chicago",
    name: "Chicago",
    country: "USA",
    year: "2021",
    sites: [
      "The Art Institute of Chicago",
      "Millennium Park",
      "Navy Pier",
      "Museum of Contemporary Art Chicago",
    ],
    photoCount: 10,
  },
];

export default cities;
